import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { Book } from "lucide-react";
import { PageTransition, JellyButton, MagicLoader } from "../components/common";
import StoryReaderPage from "./StoryReaderPage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SharedStoryPage = () => {
  const { token } = useParams();
  const [story, setStory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadSharedStory();
  }, [token]);

  const loadSharedStory = async () => {
    try {
      const res = await axios.get(`${API}/shared/${token}`);
      setStory(res.data);
    } catch (e) {
      setError("Story not found or sharing has been disabled");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen pt-24 flex items-center justify-center">
        <MagicLoader text="Loading shared story..." />
      </div>
    );
  }

  if (error) {
    return (
      <PageTransition>
        <div className="min-h-screen pt-24 flex items-center justify-center px-4">
          <div className="text-center">
            <Book className="w-20 h-20 text-slate-300 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-slate-700 mb-2">Story Not Found</h1>
            <p className="text-slate-500 mb-6">{error}</p>
            <Link to="/">
              <JellyButton variant="primary">
                Create Your Own Story
              </JellyButton>
            </Link>
          </div>
        </div>
      </PageTransition>
    );
  }

  return <StoryReaderPage isSharedView={true} sharedStory={story} />;
};

export default SharedStoryPage;
